import { useTranslation } from "@redotech/redo-i18n";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";
import * as styles from "./refresh-shipping-rates-button.module.css";

export interface RefreshShippingRatesButtonProps {
  disabled?: boolean;
  pending?: boolean;
  onClick(): void;
}

export const RefreshShippingRatesButton = memo(
  function RefreshShippingRatesButton({
    disabled,
    pending = false,
    onClick,
  }: RefreshShippingRatesButtonProps) {
    const { t } = useTranslation();
    return (
      <RedoButton
        aria-busy={pending}
        aria-label={pending ? t("Getting updated rates…") : undefined}
        buttonClassName={styles.button}
        disabled={disabled || pending}
        hierarchy="link_underline"
        onClick={onClick}
        size="sm"
        text={pending ? t("Updating rates…") : t("Get updated rates")}
        textWeight="thin"
      />
    );
  },
);
